import { GroupDividerLayout } from '@/components/table/group-divider-layout.js';
import { StartDateGroupKey } from '@/lib/table-grouping-utils.js';
import { formatDateWithDayOfWeek } from '@airreading/common';

interface SessionDateDividerProps {
  groupKey: StartDateGroupKey;
  rowCount: number;
}

export function SessionDateDivider({ groupKey, rowCount }: SessionDateDividerProps) {
  return (
    <GroupDividerLayout rowCount={rowCount}>
      {formatDateWithDayOfWeek(groupKey.instant, groupKey.timeZone)}
    </GroupDividerLayout>
  );
}
